var map = {
	"./ImagenMission.jpeg": 41133,
	"./cirgugialaparoscopica.png": 74968,
	"./cirugiaabierta.png": 69657,
	"./cirugiarobotica.png": 87842,
	"./colonoscopia.png": 22887,
	"./consultaespecializada.png": 48486,
	"./especialidades.png": 2224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15636;